import CustomError from './CustomError'

export default class ConsoleError extends CustomError {
  //* Codigo de error del servicio

  constructor(error: Partial<ConsoleError>) {
    super(error)
    this.name = this.constructor.name

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor)
    }
  }
}
